module.exports = __webpack_public_path__ + "img/heavyTransport1.png";